import { Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import StatisticsLoader from '../core/StatisticsLoader';
import TitledPanel from '../core/TitledPanel';
import { globalStyles as styles } from '../core/style/gstheme';

const statsList = [
    {
        label: "Classes",
        type: "CLASSCOUNT"
    },
    {
        label: "Top Classes",
        type: "TOPCLASSCOUNT"
    },
    {
        label: "Object Properties",
        type: "OBJECTPROPERTYCOUNT"
    },
    {
        label: "Datatype Properties",
        type: "DATATYPEPROPERTYCOUNT"
    },
    {
        label: "Annotation Properties",
        type: "ANNOTATIONPROPERTYCOUNT"
    },
    {
        label: "Named Individuals",
        type: "NAMEDINDIVIDUALCOUNT"
    },
    {
        label: "Datatypes",
        type: "DATATYPECOUNT"
    }
];

class OntologyStatistics extends React.Component {

    displayView = (data) => {

        const classes = this.props.classes;

        return <div style={{ margin: '-2px' }}>
            <Grid container spacing={2} classes={
                {
                    "spacing-xs-2": this.props.classes.fullGrid
                }}>
                <Grid item xs={6} lg={4}>
                    <TitledPanel height="full" fontSize="large" title="Basic Statistics">
                        {statsList.map((stat, index) =>
                            <div key={index}>
                                {data.some(datum => datum.viewCountType === stat.type) &&
                                    <div>
                                        <Typography className={classes.subSubHeading}>{stat.label}</Typography>
                                        <Typography data-test={stat.type} className={classes.statistic}>
                                            {
                                                data.find(datum => datum.viewCountType === stat.type).viewCount
                                            }
                                        </Typography>
                                    </div>
                                }
                            </div>
                        )}
                    </TitledPanel>
                </Grid>
                {this.props.workflow &&
                    <Grid item xs={6} lg={4}>
                        <TitledPanel dataTest="workflow-stats" fontSize="large" title="Workflow Statistics">
                            <Typography paragraph variant="caption">Deprecated resources are not included.</Typography>
                            {data.some(stat => stat.viewCountType === "UNCATEGORISEDRESOURCECOUNT") &&
                                <div>
                                    <Typography className={classes.subSubHeading}>Uncategorised Resources</Typography>
                                    <Typography data-test="uncategorised-resource-count" className={classes.statistic}>
                                        {data.find(stat => stat.viewCountType === "UNCATEGORISEDRESOURCECOUNT").viewCount}
                                    </Typography>
                                </div>
                            }
                            {data.some(stat => stat.viewCountType === "DRAFTRESOURCECOUNT") &&
                                <div>
                                    <Typography className={classes.subSubHeading}>Draft Resources</Typography>
                                    <Typography data-test="draft-resource-count" className={classes.statistic}>
                                        {data.find(stat => stat.viewCountType === "DRAFTRESOURCECOUNT").viewCount}
                                    </Typography>
                                </div>
                            }
                            {data.some(stat => stat.viewCountType === "APPROVEDRESOURCECOUNT") &&
                                <div>
                                    <Typography className={classes.subSubHeading}>Approved Resources</Typography>
                                    <Typography data-test="approved-resource-count" className={classes.statistic}>
                                        {data.find(stat => stat.viewCountType === "APPROVEDRESOURCECOUNT").viewCount}
                                    </Typography>
                                </div>
                            }
                            {data.some(stat => stat.viewCountType === "REJECTEDRESOURCECOUNT") &&
                                <div>
                                    <Typography className={classes.subSubHeading}>Rejected Resources</Typography>
                                    <Typography data-test="rejected-resource-count" className={classes.statistic}>
                                        {data.find(stat => stat.viewCountType === "REJECTEDRESOURCECOUNT").viewCount}
                                    </Typography>
                                </div>
                            }
                        </TitledPanel>
                    </Grid>

                }
            </Grid>
        </div>;
    };

    render() {

        let exportNames = ["ontologystatistics"];
        if (this.props.workflow) exportNames.push("ontologyworkflowstatistics");

        return (
            <StatisticsLoader
                component={this.props.id}
                graph={this.props.graph}
                displayView={this.displayView}
                exportNames={exportNames}>
            </StatisticsLoader>
        );
    }
}

OntologyStatistics.defaultProps = {
    workflow: false
};

OntologyStatistics.propTypes = {
    classes: PropTypes.object,
    workflow: PropTypes.bool,
    id: PropTypes.string.isRequired,
    graph: PropTypes.string.isRequired
};

export default withStyles(styles)(OntologyStatistics);